// Dto
import SeStoreDTO from "./dto/SeStoreDTO"

// Types
import { GeoData} from "@/types/geodata"

// Builders
import buildSearchEventString from "./builders/buildSearchEventString"
import buildSearchEventPackageArr from "./builders/buildSearchEventPackageArr"
import buildSearchEventLodgingTypeArr from "./builders/buildSearchEventLodgingTypeArr"

// Classes
import SearchEvent from "./classes/SearchEvent"

// Enum
import {LayoutEnum} from "@/enums/LayoutEnum"


const trackSearchEvent = (seStore: SeStoreDTO, geoData: GeoData, layout: LayoutEnum): void => {
    const beginDate: string = seStore.beginDate || ""
    const endDate: string = seStore.endDate || ""
    const search_capacity = seStore.capacity 
    const search_event: string = buildSearchEventString(seStore, geoData)
    const search_package: string[] = buildSearchEventPackageArr(seStore)
    const search_lodging_type: string[] = buildSearchEventLodgingTypeArr(seStore)

    const searchEvent = new SearchEvent(
        {
            search_event,
            search_begin_date: beginDate,
            search_end_date: endDate,
            search_capacity,
            search_package,
            search_lodging_type,
            search_engine_version: layout
        }
    )

    window.dataLayer?.push(searchEvent)
}

export default trackSearchEvent